import StaticCollectionCard from './component'

export default StaticCollectionCard
